import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ContactModal from './ContactModal'

import { stringEmpty } from '../assets/utils'

class Contact extends React.Component {

  customerName() {
    if (this.props.customer) {
      return this.props.customer.first_name + ' ' + this.props.customer.last_name
    }
  }

  customerAddress(){
    if (this.props.customer) {
      return (
        stringEmpty(this.props.customer.address.line1) + ' ' +
        stringEmpty(this.props.customer.address.line2) + ', ' +
        stringEmpty(this.props.customer.address.zipcode) + ' ' +
        stringEmpty(this.props.customer.address.state) + ' ' +
        stringEmpty(this.props.customer.address.city) + ' ' +
        stringEmpty(this.props.customer.address.country_code)
      )
    }
  }

  render() {
    var editClass = this.props.shipback.charged ? "hidden" : "edit pull-right"
    var href = this.props.shipback.charged ? "" : "#edit-contact"
    return (
      <div className="contact">
        <a data-toggle="modal" href={href} id="edit-contact-button">
          <span className={editClass}>{I18n.t('layouts.summary.contact.edit')}</span>
          <h3>{I18n.t('layouts.summary.contact.title')}</h3>
          <p>
            <label>{I18n.t('layouts.summary.contact.name')}</label>
            <span className="value">{this.customerName()}</span>
          </p>
          <p>
            <label>{I18n.t('layouts.summary.contact.email')}</label>
            <span className="value">{this.props.customer.email}</span>
          </p>
          <p>
            <label>{I18n.t('layouts.summary.contact.phone')}</label>
            <span className="value">{this.props.customer.phone}</span>
          </p>
          <p>
            <label>{I18n.t('layouts.summary.contact.address')}</label>
            <span className="value">{this.customerAddress()}</span>
          </p>
          <hr className="separator" />
        </a>
        <ContactModal />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customer,
  shipback: state.shipback
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Contact)


// WEBPACK FOOTER //
// ./app/javascript/components/components/Contact.jsx